import * as React from "react";
import { Checkbox, Grid } from "./widget";
import { bind, Control, ControlProps } from "./Control";
import { Dictionary } from "../state/types";


interface CheckboxSelectionProps extends ControlProps {
    items: Dictionary<React.ReactNode>;
}


const CheckboxSelection = (props: CheckboxSelectionProps) => {

    const binding = bind(props);
    const { singleSelect, items } = props;


    const checkedItems = binding.value
        ? Array.isArray(binding.value) ? binding.value : [binding.value]
        : [];

    const getChecked = (k: string) => {
        return singleSelect
            ? k === binding.value
            : checkedItems.indexOf(k) >= 0;
    }

    const handleChange = (k: string, isChecked: boolean) => {
        if (singleSelect) {
            binding.onChange(k);
        } else {
            const newCheckedItems = checkedItems.concat([]);
            const index = newCheckedItems.indexOf(k);
            if (isChecked && index < 0) {
                newCheckedItems.push(k);
            } else if (index >= 0) {
                newCheckedItems.splice(index, 1);
            }
            binding.onChange(newCheckedItems);
        }
    }

    const selectionItems = Object.keys(items ?? []).map((k, i) => <Grid key={k} item>
        <Checkbox checked={getChecked(k)} onChange={e => handleChange(k, e.currentTarget.checked)} value={k} /> {items[k]}
    </Grid>);


    return <Control {...props}>
        <Grid container direction="column">
            {selectionItems}
        </Grid>
    </Control>;
}

export {
    CheckboxSelection
};
